<template>
    <b-form @submit.prevent="submit">
        <b-alert :show="!!errorMessage" fade :variant="errorVariant">{{errorMessage}}</b-alert>

        <b-input type="text" v-model.trim="scanValue" class="d-inline-block mr-2" :key="isProcessing /*For re-triggering the autofocus*/"
                 style="width:230px;"
                 placeholder="Barcode"
                 required autofocus autocomplete="off"
                 :disabled="isProcessing"
                 ref="valueInput"
        />
        <b-button variant="primary" type="submit" :disabled="isProcessing">
            <span v-if="!isProcessing">Scan</span>
            <font-awesome-icon v-else icon="spinner" spin/>
        </b-button>
    </b-form>
</template>

<script>
import {UsesProductProcessApi} from "./UsesProductProcessApi";
import {PRODUCT_PROCESS_TYPE_RETURN, PRODUCT_PROCESS_TYPE_SORT} from "../../../data/productProcessType";

export default {
    name: "LabelScan",

    props: {
        location: {required: true, type: Object},
    },

    data() {
        return {
            isProcessing: false,
            scanValue: '',
            errorVariant: '',
            errorMessage: '',
            refocusInterval: setInterval(() => this.$refs['valueInput']?.focus(), 500),
        }
    },

    computed: {},

    mounted() {
    },

    beforeDestroy() {
        clearInterval(this.refocusInterval)
    },

    methods: {
        submit() {
            this.isProcessing = true
            this.errorMessage = ''

            this.$http.get(`/api/rest/dispatch-requests`, {
                params: {
                    dispatcher_type: this.location.location_type.identifier,
                    dispatcher_identifier: this.location.identifier,
                    status: ['return-announced'],
                    tracking_code: this.scanValue,
                    fields: 'id',
                    include: [
                        'dispatch_request_lines:product_identifier,sales_order_line_id',
                        'dispatch_request_lines.sales_order_line:id,ean_codes'
                    ].join(';'),
                },
            })
                .then(response => {
                    const emitValue = response.data.length > 0
                        ? response.data[0]
                        : false

                    if (this.$store.state.config.general['features-enabled']['process-return-by-order-number'] && !emitValue) {
                        this.autoCreateReturnAnnouncementFromOrderNumber()
                        return
                    }

                    clearInterval(this.refocusInterval)
                    this.$emit('success', emitValue)
                })
                .catch(e => {
                    this.errorMessage = `Fout bij het verwerken. Probeer het opnieuw.`
                    this.errorVariant = 'danger'

                    this.scanValue = ''
                    this.isProcessing = false
                })
        },
        autoCreateReturnAnnouncementFromOrderNumber() {
            this.$http.post(`/api/rest/sales-orders/${this.scanValue}/dispatch-requests/return-announced`, {
                location_type_identifier: this.location.location_type.identifier,
                location_identifier: this.location.identifier,
            })
                .then(response => {
                    // Load newly created announced-drq
                    this.$http.get(response.headers.location, {
                        params: {
                            include: [
                                'dispatch_request_lines:product_identifier,sales_order_line_id',
                                'dispatch_request_lines.sales_order_line:id,ean_codes'
                            ].join(';')
                        },
                    })
                        .then(response => {
                            this.$emit('success', response.data)
                            return
                        })
                        .catch(e => {
                            this.errorMessage = `Fout bij het verwerken. Probeer het opnieuw.`
                            this.errorVariant = 'danger'
                            this.isProcessing = false
                        })
                })
                .catch(e => {
                    if (e.response.status === 404) {
                        this.$emit('success', false)
                    }

                    console.error([e])
                    this.errorMessage = `Fout bij het verwerken. Probeer het opnieuw.`
                    this.errorVariant = 'danger'
                    this.isProcessing = false
                })
        }
    },
}
</script>

<style scoped>

</style>
